import { render, staticRenderFns } from "./MarketHome.vue?vue&type=template&id=65eec2f4&scoped=true"
import script from "./MarketHome.vue?vue&type=script&lang=js"
export * from "./MarketHome.vue?vue&type=script&lang=js"
import style0 from "./MarketHome.vue?vue&type=style&index=0&id=65eec2f4&prod&scoped=true&lang=css"
import style1 from "./MarketHome.vue?vue&type=style&index=1&id=65eec2f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65eec2f4",
  null
  
)

export default component.exports